var CompanySize = {
	"Company size": "Company size",
	"1-19 employees": "1-19 employees",
	"20-99 employees": "20-99 employees",
	"100-499 employees": "100-499 employees",
	"500-999 employees": "500-999 employees",
	"1,000-9,999 employees": "1,000-9,999 employees",
	"10,000 employees or more": "10,000 employees or more"
};

export { CompanySize as default };
